export default class GetIssueByIdError extends Error {

}